import type { SyntheticEvent } from "react";
import defaultImage from "../assets/assets/dummyProduct.png";

// Category card ki image kahan se aaye.
//
// Pehle card sirf imageCarouselDetails[0].image padhta tha — wo sab purane AWS S3
// bucket (lohawalla-image-bucket-v1.s3...amazonaws.com) par hain, jo AWS band hone
// ke baad khulte hi nahi, isliye har card par broken image icon aata tha.
// category.image (= categories.images[0]) DigitalOcean Spaces par hai aur chalta hai.
//
// Order: image -> images[] -> carousel images; amazonaws.com wale URL skip.
// Kuch na mile to placeholder.
const DEAD_HOSTS = ["amazonaws.com"];

const isUsable = (u: unknown): u is string =>
	typeof u === "string" &&
	u.trim() !== "" &&
	!DEAD_HOSTS.some((h) => u.includes(h));

export const CATEGORY_FALLBACK_IMAGE: string = defaultImage;

export function getCategoryImage(category: any): string {
	if (!category) return defaultImage;
	const candidates: unknown[] = [
		category.image,
		...(Array.isArray(category.images) ? category.images : []),
		...(Array.isArray(category.imageCarouselDetails)
			? category.imageCarouselDetails.map((c: any) => c?.image)
			: []),
	];
	const hit = candidates.find(isUsable);
	return hit ? hit.trim() : defaultImage;
}

// URL mila par load fail hua (file missing / network) — broken box ki jagah
// placeholder. data-fallback se infinite loop nahi hota.
export function onCategoryImgError(e: SyntheticEvent<HTMLImageElement>) {
	const img = e.currentTarget;
	if (img.dataset.fallback === "1") return;
	img.dataset.fallback = "1";
	img.src = defaultImage;
}
